<div class="loader-backdrop">
  <div class="loader-box">
    <span class="dot dot-1"></span>
    <span class="dot dot-2"></span>
    <span class="dot dot-3"></span>
  </div>
</div>
